<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringComponentEntry.branchName')
            }}</label>
            <ts-branch-filter @filter="setBranchList" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringComponentEntry.academicYear')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="acYearId"
              :options="acYearOptions"
              @change="getTerm"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringComponentEntry.mainProgram')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="acpId"
              :options="mainProgram"
              @change="() => (acTermId = null)"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringComponentEntry.academicTerm')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="acTermId"
              :options="listOfTerm"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringComponentEntry.scoringCycle')
            }}</label>
            <a-select style="width: 100%" v-model="cycle">
              <a-select-option :value="1">{{
                $t('studentScoringComponentEntry.monthlyScore')
              }}</a-select-option>
              <a-select-option :value="0">{{
                $t('studentScoringComponentEntry.termlyScore')
              }}</a-select-option>
              <a-select-option :value="2">{{
                $t('studentScoringComponentEntry.semesterlyScore')
              }}</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'drawerFilter',
  data() {
    return {
      loading: false,
      acYearOptions: [],
      mainProgram: [],
      termLists: [],
    }
  },
  created() {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get() {
        return this.$store.state.studentScoringComponentEntry.scoring_cycle_id
      },
      set(newValue) {
        this.$store.commit(
          'studentScoringComponentEntry/SET_SCORING_CYCLE_ID',
          newValue
        )
      },
    },
    acYearId: {
      get() {
        return this.$store.state.studentScoringComponentEntry.ac_year_id
      },
      set(newValue) {
        this.$store.commit(
          'studentScoringComponentEntry/SET_AC_YEAR_ID',
          newValue
        )
      },
    },
    acpId: {
      get() {
        return this.$store.state.studentScoringComponentEntry.acp_id
      },
      set(newValue) {
        this.$store.commit(
          'studentScoringComponentEntry/SET_MAIN_PROGRAM',
          newValue
        )
      },
    },
    acTermId: {
      get() {
        return this.$store.state.studentScoringComponentEntry.ac_term_id
      },
      set(newValue) {
        this.$store.commit(
          'studentScoringComponentEntry/SET_AC_TERM_ID',
          newValue
        )
      },
    },
    listOfTerm() {
      return this.termLists
        .filter((t) => t.acp_id == this.acpId)
        .map((el) => ({
          value: el.ac_term_id,
          label: el.term_name,
        }))
    },
  },
  methods: {
    async fetchAcYear() {
      this.loading = true
      await this.$store
        .dispatch('studentScoringComponentEntry/getAcYear')
        .then((response) => {
          this.acYearOptions = response.data.map((el) => ({
            value: el.ac_year_id,
            label: el.ac_year,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('studentScoringComponentEntry/getMainProgram')
        .then((response) => {
          this.mainProgram = response.data.map((el) => ({
            value: el.acp_id,
            label: el.acp_name_foreign,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranchList(branch) {
      this.$store.commit('studentScoringComponentEntry/SET_BRANCH_LIST', branch)
    },
    getTerm() {
      this.acpId = null
      this.acTermId = null
      this.loading = true
      this.$store
        .dispatch('studentScoringComponentEntry/getAcTerm')
        .then((response) => {
          this.termLists = response.data
          .map((el) => ({
            ac_term_id: el.ac_term_id,
            term_name: el.term_name,
            acp_id: el.sub_program.acp_id
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
